import { createVuetify } from 'vuetify'
// TODO решить проблему с импортами https://nuxt.com/docs/guide/going-further/layers#relative-paths-and-aliases
import vuetify from '../utils/ui-vuetify'

// Загружаем стили vuetify
import 'vuetify/styles'

export default defineNuxtPlugin((nuxtApp) => {
  // @ts-ignore
  nuxtApp.vueApp.use(createVuetify(vuetify))
})
